<template>
  <span>
    <b-button class="mx-1" v-b-modal.label-form-modal> Impresión de etiquetas </b-button>
    <b-modal title="Imprimir etiquetas" @show="onShow" @ok="handleOk" :ok-disabled="is_valid" id="label-form-modal">
      <template slot="modal-ok">
        <b-spinner v-if="loading" small class="mr-1"></b-spinner>
        <span>OK</span>
      </template>
      <b-form-group label="Etiqueta">
        <b-form-select
          :state="$v.label.$dirty ? !$v.label.$error : null"
          v-model="$v.label.$model"
          value-field="id"
          text-field="name"
          :options="labels"
        />
      </b-form-group>
      <b-form-group label="Formato" label-for="containerSelect">
        <v-select
          label="name"
          :reduce="(container) => container.id"
          required
          :options="container_options"
          v-model="container"
        ></v-select>
      </b-form-group>
      <b-form-group label="Lote">
        <b-form-select
          :state="$v.lot.$dirty ? !$v.lot.$error : null"
          v-model="$v.lot.$model"
          value-field="lot_id"
          text-field="lot"
          :options="lotsInProcess"
        />
      </b-form-group>
      <b-form-group>
        <label>Cantidad de etiquetas</label>
        <b-form-input
          type="number"
          :state="$v.label_qty.$dirty ? !$v.label_qty.$error : null"
          v-model="$v.label_qty.$model"
        ></b-form-input>
      </b-form-group>
    </b-modal>
  </span>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters, mapState } from "vuex";
import { PrintLabel } from "@/assets/js/printFunctions";
import { required, integer } from "vuelidate/lib/validators";

export default {
  name: "LabelForm",
  components: {
    vSelect
  },
  data() {
    return {
      loading: false,
      label: null,
      container: null,
      lot: null,
      label_qty: null,
      labels: [],
      container_options: []
    };
  },
  validations: {
    label: { required },
    container: { required },
    lot: { required },
    label_qty: { required, integer }
  },
  computed: {
    ...mapState("alfaberriesProcess", ["product_set"]),
    ...mapGetters("alfaberriesProcess", ["lotsInProcess"]),
    is_valid() {
      return !this.container || this.loading || !this.lot || !this.label || !this.label_qty;
    }
  },
  methods: {
    onShow() {
      // this.container = null;
      this.lot = null;
      this.getLabels();
      this.getContainers();
    },
    handleOk(evt) {
      evt.preventDefault();
      if (!this.loading) {
        this.loading = true;
        this.printLabel();
      }
    },
    async printLabel() {
      const thisV = this;
      let url = "";
      url = `api/v1/box-label/${thisV.label}/render_zpl/?lot_id=${thisV.lot}&container_id=${thisV.container}&process_id=${thisV.$route.params.id}`;
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: url
        });
        thisV.$toast.info(`Enviando a impresora...`, "");
        thisV.loading = false;
        this.$bvModal.hide("label-form-modal");
        PrintLabel(response.data.code, thisV.label_qty);
      } catch (error) {
        console.log(error);
        this.$bvModal.hide("label-form-modal");
        thisV.loading = false;
        this.$toast.error("Ocurrió un error", "");
      }
    },
    async getContainers() {
      const thisV = this;
      thisV.loading = false;
      try {
        const res = await this.$axios.get("/api/v1/container/all_not_bulk/");
        thisV.container_options = res.data;
        thisV.loading = false;
      } catch (error) {
        thisV.$toast.error("Ocurrio un error al cargar datos", "");
        thisV.loading = false;
      }
    },
    async getLabels() {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      url = `api/v1/box-label/`;
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: url
        });
        thisV.labels = response.data;
        thisV.loading = false;
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.detail, "");
        thisV.loading = false;
      }
    }
  }
};
</script>

<style></style>
